module.exports = __webpack_public_path__ + "img/1642.6b74f639.jpg";